import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePartnersMediaFilesPartnerMediaFileId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { MEDIA_FILES_QUERY_KEYS } from "MusicAudio/Api/Queries/queryKeys";

export function useDeleteMediaFileMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse((partnerMediaFileID: string) =>
    deletePartnersMediaFilesPartnerMediaFileId(partnerMediaFileID),
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: MEDIA_FILES_QUERY_KEYS.all,
      });
    },
  });
}
